<template>
  <span data-test-id="LogoutComponent">
    <div class="text-red" data-test-id="logoutButton" role="button" tabindex="0" @click="onLogoutClick">Logout</div>
  </span>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Logout",
  methods: {
    ...mapActions("Login", ["logout"]),
    onLogoutClick() {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to logout?", {
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((logout) => {
          if (logout) {
            this.logout();
          }
        })
        .catch(() => {
          // console.log("logout error", error);
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
  float: right;
  text-align: right;
}
</style>
